import React, { SelectHTMLAttributes, forwardRef } from 'react';

import { ExpandMore } from '@material-ui/icons';

import { useI18n } from 'Hooks';

import { Icon, SelectBox, Wrapper } from './styles';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: { title: string | number; value: any }[];
  label?: string;
  placeholder?: string;
}

const Select = ({ options, label, placeholder, ...rest }: SelectProps, ref) => {
  const { t } = useI18n();
  const optionsList = options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.title}
    </option>
  ));

  return (
    <Wrapper>
      <SelectBox ref={ref} {...rest}>
        <option value="" disabled selected>
          {placeholder ?? t('General.Choose')}
        </option>
        {optionsList}
      </SelectBox>
      <Icon>
        <ExpandMore htmlColor="#8b8f93" />
      </Icon>
    </Wrapper>
  );
};

export default forwardRef(Select);
